import { render, staticRenderFns } from "./LookShopDetail.vue?vue&type=template&id=6253ad3c&scoped=true"
import script from "./LookShopDetail.vue?vue&type=script&lang=ts"
export * from "./LookShopDetail.vue?vue&type=script&lang=ts"
import style0 from "./LookShopDetail.vue?vue&type=style&index=0&id=6253ad3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6253ad3c",
  null
  
)

export default component.exports